import {
    ActionTypeEnum, DailyTransactionTypeEnum, GenericSystemConfigurationModel, PaymentTypeEnum,
    RequestActionModel, ResponseBaseModel, RowStateEnum,
    TransactionDetailResponseModel, TransactionItemResponseModel,
    TransactionResponseModel,
    UserConfigurationModel,
    ValidateTransactionModeEnum,
    ValidationErrorModel
} from "../../../../models";
import {validateTransactionEligibilityByAction} from "../../../../serviceBroker/transactionApiServiceBroker";
import { getLabelName } from "../../../../utils";
import {isConfiguredForSavePurchaseFromTransaction} from "./commonBl";
//#region validation functions
export const isTransactionConfiguredForSavePurchaseFromTransaction = (
    transactionType: DailyTransactionTypeEnum,
    configurations?: GenericSystemConfigurationModel|null
): boolean =>
    !!configurations?.IsSavePurchaseTransactionFromSalesForBalanceLessTHanZero &&
    Array.isArray(configurations?.TransactionTypeIdsConfigureToSavePurchaseFromTransaction) &&
    configurations.TransactionTypeIdsConfigureToSavePurchaseFromTransaction.includes(transactionType);

export const getValidationChainByActionType = (
    record: TransactionDetailResponseModel | null,
    transactionType: DailyTransactionTypeEnum,
    actionType: ActionTypeEnum,
): (() => Promise<ValidationErrorModel[]>)[] => {
    const key = `${actionType}_${transactionType}`;
    switch (key){
        case `${ActionTypeEnum.IssueSaleTransactionFromSalePrice}_${DailyTransactionTypeEnum.SalesInvoice}`:
            return [
                () => Promise.resolve(validateTransactionNotFoundError(record)),
                () => validateGetTransactionAsSourceDetails(record),
            ];
        case `${ActionTypeEnum.Update}_${DailyTransactionTypeEnum.SalesInvoice}`:
        case `${ActionTypeEnum.Update}_${DailyTransactionTypeEnum.PurchasesInvoice}`:
        case `${ActionTypeEnum.Update}_${DailyTransactionTypeEnum.SalesRefund}`:
        case `${ActionTypeEnum.Update}_${DailyTransactionTypeEnum.PurchasesRefund}`:
        case `${ActionTypeEnum.ModifyStart}_${DailyTransactionTypeEnum.SalesInvoice}`:
        case `${ActionTypeEnum.ModifyStart}_${DailyTransactionTypeEnum.PurchasesInvoice}`:
        case `${ActionTypeEnum.ModifyStart}_${DailyTransactionTypeEnum.SalesRefund}`:
        case `${ActionTypeEnum.ModifyStart}_${DailyTransactionTypeEnum.PurchasesRefund}`:
            // Base validation chain
            const validations = [() => Promise.resolve(validateTransactionNotFoundError(record))];
            // Add eligibility validation only if record is not null
            if (record) {
                validations.push(() =>
                    Promise.resolve(
                        validateTransactionEligibility({
                            transactionId: record.ID,
                            creationDate: record.Date ,
                            totalTax: record.TotalTax,
                            mode: ValidateTransactionModeEnum.Modify,
                        })
                    )
                );
            }

            return validations;
        default:
            return [() => Promise.resolve(validateTransactionNotFoundError(record)),
            ];
    }
    // switch (actionType) {
    //     case ActionTypeEnum.IssueSaleTransactionFromSalePrice:
    //         return [
    //             () => Promise.resolve(validateTransactionNotFoundError(record)),
    //             () => validateGetTransactionAsSourceDetails(record),
    //         ];
    //
    //     case ActionTypeEnum.Update:
    //     case ActionTypeEnum.ModifyStart:
    //         return [
    //             () => Promise.resolve(validateTransactionNotFoundError(record)),
    //             // You can add more validators for update/edit actions here
    //         ];
    //
    //     default:
    //         return [
    //             () => Promise.resolve(validateTransactionNotFoundError(record)),
    //             // You can add more validators for update/edit actions here
    //         ];
    // }
};
export const runSequentialValidations = async (
    validators: (() => Promise<ValidationErrorModel[]>)[] // array of async validator functions
): Promise<ValidationErrorModel[]> => {
    const allErrors: ValidationErrorModel[] = [];
    for (const validator of validators) {
        const errors = await validator();
        if (errors.length > 0) {
            allErrors.push(...errors);
            break; // Stop on first error
        }
    }

    return allErrors;
};
export const validateTransactionNotFoundError = (
    request: TransactionDetailResponseModel|null
): ValidationErrorModel[] => {
    if (request == null) {
        return [
            {
                MessageAr: getLabelName("Transaction not found"),
                MessageEn: getLabelName("Transaction not found"),
            },
        ];
    }
    return [];
};
export const validateTransactionObject = async (
    row: TransactionResponseModel,
    mode: ValidateTransactionModeEnum,
    onActionEvent: (o: RequestActionModel) => void
): Promise<boolean> => {
    let result = await validateTransactionEligibilityByAction({
        transactionId:row.id,
        creationDate:row.creationDate,
        totalTax:row.totalTax,
        mode:mode
    });
    if (
        result.Errors !== null &&
        result.Errors !== undefined &&
        result.Errors.length !== 0
    ) {
        //return  true;
        result.Result = false;
        onActionEvent({
            id: 0,
            request: result.Errors,
            action: ActionTypeEnum.RaiseError,
        });
    }
    return result.Result || false;
};
export const validateTransactionEligibility = async ({
                                                          transactionId,
                                                          creationDate,
                                                          totalTax,
                                                          mode,
                                                      }: {
    transactionId: number;
    creationDate: Date;
    totalTax: number;
    mode: ValidateTransactionModeEnum;
}): Promise<ValidationErrorModel[]> => {
    const result = await validateTransactionEligibilityByAction({
        transactionId,
        creationDate,
        totalTax,
        mode
    });
    return result?.Errors||[];
};
export const validateRefundSubmitRequestAdditionalValidation = async (
    request: TransactionDetailResponseModel
): Promise<ValidationErrorModel[]> => {
    let errors: ValidationErrorModel[] = [];
    request.TransactionDetaillist.forEach((row) => {
        if (row.Quantity > row.MaxQty) {
            errors.push({
                MessageAr: `${getLabelName("max Quantity Exceeded")} ${row.ItemName}`,
                MessageEn: `${getLabelName("max Quantity Exceeded")} ${
                    row.ItemName_En
                }`,
            });
        }
    });
    return errors;
};
export const validateSubmitRequest = async (
    request: TransactionDetailResponseModel,userConfiguration: UserConfigurationModel
): Promise<ValidationErrorModel[]> => {
    let errors: ValidationErrorModel[] = [];
    // Validate basic details
    const basicValidationErrors = await validateTransactionBasicDetails({
        request,
        userConfiguration
    });

    if (basicValidationErrors && basicValidationErrors.length > 0) {
        errors.push(...basicValidationErrors);
        return errors;
    }
    // Validate items
    const activeTransactionItems = request.TransactionDetaillist.filter(
        item => item.rowState !== RowStateEnum.Delete
    );
    for (const row of activeTransactionItems) {
        const itemErrors = await validateAddItem(row, userConfiguration);
        if (itemErrors && itemErrors.length > 0) {
            errors.push(...itemErrors);
        }
    }
    if (errors && errors.length > 0) {
        return errors;
    }
    // Validate additional business rules
    errors=errors??[];
    const logicErrors = await validateBusinessRules({
        request,
        userConfiguration
    });

    if (logicErrors && logicErrors.length > 0) {
        errors.push(...logicErrors);
    }
    return errors;
};
export const isDateValid = (date: Date, daysToAdd: number): boolean => {
    const inputDate = new Date(date);
    const targetDate = new Date(inputDate.getFullYear(), inputDate.getMonth(), inputDate.getDate() + daysToAdd);
    const today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
    return targetDate <= today;
};
export const validateTransactionBasicDetails  =async({  request,userConfiguration}:{request: TransactionDetailResponseModel,userConfiguration: UserConfigurationModel}):Promise<ValidationErrorModel[]>=>{
    let errors: ValidationErrorModel[] = [];
    const canSavePurchaseTransactionFromSales = isConfiguredForSavePurchaseFromTransaction(request.TransactionType,userConfiguration);
    if ((request.PaymentTypeIdForSupplier == null || request.PaymentTypeIdForSupplier==0) && canSavePurchaseTransactionFromSales ) {
        errors.push({
            MessageAr: getLabelName("Supplier Payment Type Is Required"),
            MessageEn: getLabelName("Supplier Payment Type Is Required"),
        });
    }
    if (request.Customer_ID == null || request.Customer_ID==0 ) {
        const msg:string =getCustomerIdError(request.TransactionType as DailyTransactionTypeEnum) ;
        errors.push({
            MessageAr: getLabelName(msg),
            MessageEn: getLabelName(msg),
        });
    }
    if (userConfiguration?.userSetting?.SelectionEmployeeIsRequierd && request.Emp_ID == null ) {
        errors.push({
            MessageAr: getLabelName("employeeId missing"),
            MessageEn: getLabelName("employeeId missing"),
        });
    }
    if (request.Date == null) {
        errors.push({
            MessageAr: getLabelName("date missing"),
            MessageEn: getLabelName("date missing"),
        });
    }
    if (request?.TransactionDetaillist?.filter(item=>item.rowState!=RowStateEnum.Delete).length === 0) {
        errors.push({
            MessageAr: getLabelName("no items in transaction"),
            MessageEn: getLabelName("no items in transaction"),
        });
    }
    const validatePaymentTypeErrors=await validatePaymentType({request,userConfiguration});
    errors.push(...validatePaymentTypeErrors);

    return errors;
}
export const validateAddItem = async (
    request: TransactionItemResponseModel,
    userConfiguration:UserConfigurationModel
): Promise<ValidationErrorModel[]> => {
    let errors: ValidationErrorModel[] = [];
    if (request.Categ_ID === null || request.Categ_ID === undefined) {
        errors.push({
            MessageAr: getLabelName("categoryId missing"),
            MessageEn: getLabelName("categoryId missing"),
        });
    }
    if (
        request.ItemInstore_ID == null ||
        request.ItemInstore_ID == 0
    ) {
        errors.push({
            MessageAr: getLabelName("itemId missing"),
            MessageEn: getLabelName("itemId missing"),
        });
    }
    // if (
    //     request.storeId == null ||
    //     request.storeId == 0
    // ) {
    //     errors.push({
    //         MessageAr: getLabelName("storeId missing"),
    //         MessageEn: getLabelName("storeId missing"),
    //     });
    // }
    if (request.ItemUnit_ID == null ) {
        errors.push({
            MessageAr: getLabelName("unitId missing"),
            MessageEn: getLabelName("unitId missing"),
        });
    }
    if (
        request.Quantity == null ||
        request.Quantity <= 0
    ) {
        errors.push({
            MessageAr: getLabelName("quantity missing"),
            MessageEn: getLabelName("quantity missing"),
        });
    }
    if (
        request.Unit_Price == null
        // ||request.Unit_Price <= 0
    ) {
        errors.push({
            MessageAr: getLabelName("price missing"),
            MessageEn: getLabelName("price missing"),
        });
    }
    // if(!userConfiguration?.userSetting?.AllowItemPriceSaleLessThanCost && request.Unit_Price < (request.CostPrice??0)){
    //   errors.push({
    //     MessageAr: getLabelName("Unit Price Is lower Than Cost Price"),
    //     MessageEn: getLabelName("Unit Price Is lower Than Cost Price"),
    //   });
    // }
    return errors;
};
//#endregion
//#region validation business rules
export const validateBusinessRules=async({  request,userConfiguration}:{request: TransactionDetailResponseModel,userConfiguration: UserConfigurationModel}):Promise<ValidationErrorModel[]>=>{
    let errors: ValidationErrorModel[] = [];
    switch (request.TransactionType){
        case DailyTransactionTypeEnum.SalesInvoice:
            errors.push(...await validateAllowItemPriceSaleLessThanCostBusinessRule({request,userConfiguration}));
            errors.push(...await validateAllowSaleLessThanCostBusinessRule({request,userConfiguration}));
            break;
        default:

            break;
    }
    return  errors;
}
export const validateAllowItemPriceSaleLessThanCostBusinessRule=async({  request,userConfiguration}:{request: TransactionDetailResponseModel,userConfiguration: UserConfigurationModel}):Promise<ValidationErrorModel[]>=> {
    let errors: ValidationErrorModel[] = [];
    if (!userConfiguration?.userSetting.AllowItemPriceSaleLessThanCost) {
        const items = request.TransactionDetaillist.filter(
            (p) => p.rowState !== RowStateEnum.Delete
        );
        items.forEach((row) => {
            if (row.Unit_Price < (row.PriceCost??0)) {
                errors.push({
                    MessageAr: `${getLabelName("item price less than cost price")} ${row.ItemName}`,
                    MessageEn: `${getLabelName("item price less than cost price")} ${row.ItemName_En}`,
                });
            }
        });
    }
    return errors;
}
export const validateAllowSaleLessThanCostBusinessRule=async({  request,userConfiguration}:{request: TransactionDetailResponseModel,userConfiguration: UserConfigurationModel}):Promise<ValidationErrorModel[]>=> {
    let errors: ValidationErrorModel[] = [];
    if (!userConfiguration?.userSetting.AllowSaleLessThanCost) {
        const items = request.TransactionDetaillist.filter(
            (p) => p.rowState !== RowStateEnum.Delete
        );
        const totalCostPrice=items.reduce((acc, item) => acc + (item.PriceCost??0) * item.Quantity, 0);
        //const totalSalePrice=items.reduce((acc, item) => acc + item.Unit_Price * item.Quantity, 0);
        if (request.TotalNet < totalCostPrice) {
            errors.push({
                MessageAr: getLabelName("total price less than total cost price"),
                MessageEn: getLabelName("total price less than total cost price"),
            });
        }
    }
    return errors;
}
export const validatePaymentType=async({  request,userConfiguration}:{request: TransactionDetailResponseModel,userConfiguration: UserConfigurationModel}):Promise<ValidationErrorModel[]>=> {
    if (request?.DueDate == null && request.PaymentType_ID == PaymentTypeEnum.Delay  && userConfiguration.userSetting.RequestDueDateOnDelayPayment) {
        return [{
            MessageAr: getLabelName("due date missing"),
            MessageEn: getLabelName("due date missing"),
        }]
    }
    return [];
}
//#endregion
//#region validation refund functions
export const validateGetRefundRequestDetails = async (
    request: ResponseBaseModel<TransactionDetailResponseModel> | null
): Promise<ValidationErrorModel[]> => {
    let errors: ValidationErrorModel[] = [];
    if (request?.Errors?.length) {
        errors.push(...request.Errors);
        return  errors;
    }

    if (!request?.Result?.TransactionDetaillist?.length) {
        errors.push(
            {
                MessageAr: getLabelName("no items for refund"),
                MessageEn: getLabelName("no items for refund"),
            }
        );
    }
    return errors;
};
export const validateRefundPeriodExpired=async (request: TransactionDetailResponseModel,userConfiguration:UserConfigurationModel,transactionType:DailyTransactionTypeEnum ): Promise<ValidationErrorModel[]> => {
    let errors: ValidationErrorModel[] = [];
    const transactionConfiguration = userConfiguration?.userTransactionSettings?.find(
        p => p.TransactionType_ID == transactionType
    ) ?? null;

    if (!isDateValid(request.Date, transactionConfiguration?.PeriodAllowForReturn??0)) {
        errors.push({
            MessageAr: getLabelName("refund period expired"),
            MessageEn: getLabelName("refund period expired"),
        });
    }
    return errors;
}
//#endregion
//#region validation edit functions
export const validateGetTransactionAsSourceDetails = async (
    request:TransactionDetailResponseModel | null
): Promise<ValidationErrorModel[]> => {
    let errors: ValidationErrorModel[] = [];
    if (!request?.TransactionDetaillist?.length) {
        errors.push(
            {
                MessageAr: getLabelName("no items"),
                MessageEn: getLabelName("no items"),
            }
        );
    }
    return errors;
};
//#endregion
//#region private
const getCustomerIdErrorByTransaction: Partial<
    Record<DailyTransactionTypeEnum, string>
> = {
    [DailyTransactionTypeEnum.SalesInvoice]: "customerid_missing",
    [DailyTransactionTypeEnum.PurchasesInvoice]: "supplierid_missing",
    [DailyTransactionTypeEnum.SalesRefund]: "customerid_missing",
    [DailyTransactionTypeEnum.PurchasesRefund]: "supplierid_missing",
};
const getCustomerIdError = (transactionType: DailyTransactionTypeEnum): string => {
    return getCustomerIdErrorByTransaction[transactionType] ?? "customerid_missing";
};
//#endregion
